namespace $.$$ {
	
	$mol_style_define( $hyoo_budget_transfer_row, {
		
		Amount: {

			flex: {
				basis: `5rem`,
			},

			String: {
				textAlign: 'end',
			},

		},

		Description: {
			flex: {
				shrink: 1000,
			},
		},
		
	} )
	
}
